import { ServiceResult } from '../models/api-shared.models';
import { ChatPrompt, ChatRequest, ChatResult, EvaluateChatRequest } from '../models/chat.models';
import ApiService from './api-service';

class ChatService extends ApiService {
  private static classInstance: ChatService;
  private getChatAbortController: AbortController;

  private constructor() {
    super('AI');
    this.getChatAbortController = new AbortController();
  }

  public abortGetChat = (): void => {
    this.getChatAbortController.abort();
  };

  public getChat(request: ChatRequest): ServiceResult<ChatResult> {
    this.getChatAbortController = new AbortController();
    return this.post(
      `${this.baseUrl}/ProductCatalogConversation`,
      request,
      undefined,
      this.getChatAbortController.signal
    );
  }

  public evaluateChat(request: EvaluateChatRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/EvaluateProductCatalogConversation`, request);
  }

  public getPrompts(): ServiceResult<ChatPrompt[]> {
    return this.get(`${this.baseUrl}/GetProductCatalogConversationPrompts`);
  }

  public static getInstance(): ChatService {
    if (!this.classInstance) {
      this.classInstance = new ChatService();
    }
    return this.classInstance;
  }
}

export default ChatService;
